@if (filterableColumns.length > 0) {
  <div class="maestro-filter-container">
    <!-- Primera fila: Select de filtros y botón limpiar -->
    <div class="filter-row filter-row-first">
      @if (availableColumns.length > 0) {
        <nz-select
          [(ngModel)]="selectedFilterColumn"
          (ngModelChange)="onFilterColumnChange($event)"
          nzPlaceHolder="Agregar filtro..."
          nzAllowClear
          style="width: 180px; margin-right: 8px;">
          @for (column of availableColumns; track column.name) {
            <nz-option [nzValue]="column.name" [nzLabel]="column.name"></nz-option>
          }
        </nz-select>
      }

      <!-- Botón para limpiar todos los filtros -->
      @if (activeFilters.length > 0) {
        <button
          (click)="clearAllFilters()"
          nz-button
          nzShape="round"
          nzType="text"
          nzSize="default"
          nz-tooltip
          nzTooltipTitle="Limpiar todos los filtros"
          class="clear-all-btn">
          <app-st-icon name="close" [bold]="true"></app-st-icon>
          Limpiar
        </button>
      }
    </div>

    <!-- Segunda fila: Campo de opción, botón confirmar y filtros activos -->
    <div class="filter-row filter-row-second">
      <!-- Campo de filtro según el tipo -->
      @if (showFilterInput && currentFilterColumn) {
        @if (currentFilterType === 'date') {
          <nz-date-picker
            [(ngModel)]="filterValue"
            (ngModelChange)="onFilterValueChange($event)"
            nzPlaceHolder="Seleccionar fecha"
            style="width: 180px; margin-right: 8px;">
          </nz-date-picker>
        } @else if (currentFilterType === 'select') {
          <nz-select
            [(ngModel)]="filterValue"
            (ngModelChange)="onFilterValueChange($event)"
            nzPlaceHolder="Seleccionar opción"
            nzAllowClear
            nzShowSearch
            [nzNotFoundContent]="noFilterResultsTmpl"
            style="width: 180px; margin-right: 8px;">
            @if (currentFilterColumn.optionList) {
              @for (option of currentFilterColumn.optionList; track option.id) {
                <nz-option
                  [nzValue]="option.id"
                  [nzLabel]="getOptionLabel(option, currentFilterColumn)">
                </nz-option>
              }
            }
          </nz-select>
        } @else if (currentFilterType === 'multi-select') {
          <nz-select
            [(ngModel)]="filterValue"
            (ngModelChange)="onFilterValueChange($event)"
            nzPlaceHolder="Seleccionar compañías"
            nzAllowClear
            nzMode="multiple"
            [nzMaxTagCount]="1"
            class="maestro-filter-multiselect"
            style="width: 180px; margin-right: 8px;">
            @if (currentFilterColumn.optionList) {
              @for (option of currentFilterColumn.optionList; track option.id) {
                <nz-option
                  [nzValue]="option.id"
                  [nzLabel]="getOptionLabel(option, currentFilterColumn)">
                </nz-option>
              }
            }
          </nz-select>
        } @else if (currentFilterType === 'boolean') {
          <nz-select
            [(ngModel)]="filterValue"
            (ngModelChange)="onFilterValueChange($event)"
            nzPlaceHolder="Seleccionar"
            nzAllowClear
            style="width: 150px; margin-right: 8px;">
            <nz-option [nzValue]="true" nzLabel="Sí"></nz-option>
            <nz-option [nzValue]="false" nzLabel="No"></nz-option>
          </nz-select>
        } @else if (currentFilterType === 'text' || currentFilterType === 'number') {
          <input
            nz-input
            [(ngModel)]="filterValue"
            (ngModelChange)="onFilterValueChange($event)"
            [placeholder]="'Filtrar ' + selectedFilterColumn"
            style="width: 180px; margin-right: 8px;"/>
        }

        <!-- Botón para agregar el filtro -->
        @if (canAddFilter) {
          <button
            (click)="addFilter()"
            nz-button
            nzType="default"
            nzSize="default"
            nzShape="circle"
            nz-tooltip
            nzTooltipTitle="Agregar filtro"
            style="margin-right: 8px;">
            <app-st-icon name="add" [bold]="true"></app-st-icon>
          </button>
        }
      }

      <!-- Filtros activos -->
      @for (activeFilter of activeFilters; track activeFilter.columnName) {
        <span class="st-badget subtle-grey active-filter-item">
          <span class="filter-label">{{ activeFilter.columnName }}:</span>
          <span class="filter-value">
            @if (activeFilter.column.pathData?.type === 'boolean') {
              {{ activeFilter.filterValue ? 'Sí' : 'No' }}
            } @else if (activeFilter.column.pathData?.type === 'select' || activeFilter.column.pathData?.type === 'avatar-select') {
              @if (activeFilter.column.optionList) {
                @for (option of activeFilter.column.optionList; track option.id) {
                  @if (option.id === activeFilter.filterValue) {
                    {{ getOptionLabel(option, activeFilter.column) }}
                  }
                }
              }
            } @else if (activeFilter.column.pathData?.type === 'multi-select') {
              @if (activeFilter.column.optionList && isArray(activeFilter.filterValue)) {
                @for (optionId of activeFilter.filterValue; track optionId; let last = $last) {
                  @for (option of activeFilter.column.optionList; track option.id) {
                    @if (option.id === optionId) {
                      {{ getOptionLabel(option, activeFilter.column) }}@if (!last) {, }
                    }
                  }
                }
              }
            } @else if (activeFilter.column.pathData?.type === 'date') {
              {{ activeFilter.filterValue | date: 'dd/MM/yyyy' }}
            } @else {
              {{ activeFilter.filterValue }}
            }
          </span>
          <button
            (click)="removeFilter(activeFilter.columnName); $event.stopPropagation()"
            nz-button
            nzType="text"
            nzShape="circle"
            nzSize="small"
            nz-tooltip
            nzTooltipTitle="Eliminar filtro"
            class="remove-filter-btn"
            style="padding: 0; min-width: auto; height: auto; margin-left: 4px;">
            <app-st-icon name="close" [bold]="true" style="font-size: 12px;"></app-st-icon>
          </button>
        </span>
      }
    </div>
  </div>
}

<!-- Mensaje mostrado dentro del desplegable cuando la búsqueda no arroja coincidencias -->
<ng-template #noFilterResultsTmpl>
  <span>No se encontraron resultados para {{ selectedFilterColumn }}</span>
</ng-template>

